import axios from "axios";

export const sendOTP = async (authtoken,id,number) => {
    return await axios.post(
      `${process.env.REACT_APP_BACKEND_API}/user/${id}/send-otp`,
      {number},
      {
        headers: {
          authtoken,
        },
      }
    );
  };

  export const addToTeacher = async (authtoken,token) => {
    return await axios.post(
      `${process.env.REACT_APP_BACKEND_API}/user-teacher/${token}/email-check`,
      {},
      {
        headers: {
          authtoken,
        },
      }
    );
  };